import { render, staticRenderFns } from "./PetFooter.vue?vue&type=template&id=11c15dd2&scoped=true&"
import script from "./PetFooter.vue?vue&type=script&lang=js&"
export * from "./PetFooter.vue?vue&type=script&lang=js&"
import style0 from "./PetFooter.vue?vue&type=style&index=0&id=11c15dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c15dd2",
  null
  
)

export default component.exports